export function setCookie(name, value, days) {
  const expires = days ? `; Expires=${new Date(Date.now() + days * 864e5).toUTCString()}` : '';
  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}${expires}; Path=/; SameSite=Lax`;
}

export function getCookie(name) {
  const m = document.cookie.match(new RegExp('(?:^|; )' + encodeURIComponent(name) + '=([^;]*)'));
  return m ? decodeURIComponent(m[1]) : null;
}

export function deleteCookie(name) {
  document.cookie = `${encodeURIComponent(name)}=; Expires=Thu, 01 Jan 1970 00:00:00 GMT; Path=/`;
}